import { HTMLAttributes, RefAttributes, forwardRef } from 'react';
import {
  DALLAS_BACKGROUND_COLOR_CLASSNAME_SEGMENTS,
  DallasBackgroundColor,
} from '../types/background';
import clsx from 'clsx';
import DallasText from '../Text/DallasText';

import styles from './DallasTag.module.scss';

type DallasTagTextVariant = 'captionL' | 'captionM';

export interface Props extends HTMLAttributes<any>, RefAttributes<any> {
  /**
   * Tag text
   */
  text: string;
  /**
   * Optional className
   */
  className?: string;
  /**
   * Specifies the color scheme.
   */
  color?: DallasBackgroundColor;
  /**
   * Optional text variant.
   */
  textVariant?: DallasTagTextVariant;
  /**
   * Specifies if the tag has a border.
   */
  bordered?: boolean;
  /**
   * Specifies that the corners should be rounded.
   */
  rounded?: boolean;
  /**
   * Optional add-on element to be displayed at the start of the tag.
   */
  addOnStart?: React.ReactElement;
  /**
   * Optional add-on element to be displayed at the end of the tag.
   */
  addOnEnd?: React.ReactElement;
}

const DallasTag = forwardRef<any, Props>(function DallasTag(
  {
    className,
    color = 'lightGray',
    bordered = false,
    rounded = false,
    text,
    addOnStart,
    addOnEnd,
    textVariant = 'captionL',
    ...divProps
  },
  ref,
) {
  return (
    <div
      {...divProps}
      ref={ref}
      className={clsx(
        className,
        styles.root,
        styles[`iconSize-${textVariant}`],
        styles[`color-${DALLAS_BACKGROUND_COLOR_CLASSNAME_SEGMENTS[color]}`],
        bordered ? styles.bordered : styles.borderless,
        rounded ? styles.borderRadius_rounded : styles.borderRadius_semiRounded,
      )}
    >
      {addOnStart}
      <DallasText variant={textVariant}>{text}</DallasText>
      {addOnEnd}
    </div>
  );
});

export default DallasTag;
